import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../providers/CustomAuthProvider';
import NotEnoughAccess from '../pages/error/NotEnoughAccess';
import NotAuthorised from '../pages/error/NotAuthorised';
const PrivateRoute = ({ layout: Layout, component: Component, AdminAccessOnly = false, SystemAdminAccessOnly = false, ModuleAccess = null, ...rest }) => {
    const { loginWithRedirect, isAuthenticated, isAdmin, isSystemAdmin, hasDatahubAccess, loadPremiumFlag } = useAuth();

    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        if (!isAuthenticated || hasDatahubAccess !== true) return;
        loadPremiumFlag(ModuleAccess);
    }, [ModuleAccess, hasDatahubAccess, isAuthenticated, loadPremiumFlag]);

    const renderWithLayout = (children, layoutProps = {}) => {
        if (!Layout) return <>{children}</>;

        return <Layout {...layoutProps}>{children}</Layout>;
    };



    if (!isAuthenticated) {
        loginWithRedirect({});
        return null;
    }
    if (hasDatahubAccess === null) return null;

    if (!hasDatahubAccess) {
        return renderWithLayout(<NotAuthorised />, {
            isAdmin: false,
            isAuthorised: true,
        });
    }

    if (AdminAccessOnly && !isAdmin) {
        return renderWithLayout(<NotEnoughAccess />, {
            isAdmin,
            isAuthorised: hasDatahubAccess,
        });
    }

    if (SystemAdminAccessOnly && !isSystemAdmin) {
        return renderWithLayout(<NotEnoughAccess />, {
            isAdmin,
            isAuthorised: hasDatahubAccess,
        });
    }

    // if (ModuleAccess && !hasModuleAccess(ModuleAccess)) {
    //     return (
    //         <Layout isAdmin={isAdmin} isAuthorised={hasDatahubAccess}>
    //             <NotEnoughAccess />
    //         </Layout>
    //     );
    // }


    const history = {
        push: (to, state) => navigate(to, { state }),
        replace: (to, state) => navigate(to, { replace: true, state }),
        goBack: () => navigate(-1),
    };
    const match = { params };

    return renderWithLayout(
        <Component {...rest} location={location} history={history} match={match} />,
        {
            isAdmin,
            isAuthorised: hasDatahubAccess,
        }
    );
};

export default PrivateRoute;
